import React from 'react';
import './AccountMobileNavigation.scss';

/**
 * Renders the mobile version of the account navigation
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const AccountMobileNavigation = ({ customer, isOpenMenu, setIsOpenMenu }) => (
  <div className="c-account-mobile-navigation">
    <h2 className="c-account-mobile-navigation__heading h2-roobert">
      Welcome{customer.firstName ? `, ${customer.firstName}` : ''}
    </h2>
    <div className="c-account-mobile-navigation__wrapper">
      <div
        className={`c-account-mobile-navigation__input h2-roobert ${
          isOpenMenu === true ? 'is-open' : ''
        }`}
      >
        <div
          className="c-account-mobile-navigation__visible-section"
          onClick={() => {
            setIsOpenMenu(!isOpenMenu);
          }}
        >
          <p id="visibleSection">My Account</p>
          <div className="dropdown-arrow"></div>
        </div>
        <p>
          <a href="account">My Account</a>
        </p>
        <p>
          <a href="/account#history">Order History</a>
        </p>
        <p>
          <a href="/account/logout">Log Out</a>
        </p>
      </div>
    </div>
  </div>
);

export default AccountMobileNavigation;
